import { createVersionedComponentLoader } from '../../../../VersionedComponentLoader';
import { VersionedComponents, VersionedContext } from '../../../../constants';

export const DataExchangeLayerPreview = ({ formData, i18n, defaultOpen }) =>
  createVersionedComponentLoader(
    VersionedContext.PREVIEW,
    VersionedComponents.DATAEXCHANGELAYERPREVIEW
  )(formData.formSchemaVersion)({
    formData,
    i18n,
    defaultOpen
  });
